import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as canalproRoutes } from './canalpro/routes';
import { routes as imoveisRoutes } from './imoveis/routes';
import { routes as visitasRoutes } from './visitas/routes';
import { routes as financeiroRoutes } from './financeiro/routes';
import { routes as administracaoRoutes } from './administracao/routes';
import { routes as relatorioRoutes } from './relatorio/routes';
import { routes as brandVoiceRoutes } from './brandVoice/routes';
import { routes as realEstateRoutes } from './realEstate/realEstate.routes';
import { routes as operacaoImobiliariaRoutes } from './operacaoImobiliaria/routes';
import { routes as pendingMarketUpdatesRoutes } from './pendingMarketUpdates/routes';
import { routes as mudancasRoutes } from './mudancas/routes';
import { routes as planosRoutes } from './laisPlans/routes';
import { routes as inicioRoutes } from './laisDashboard/routes';
import { routes as laisReferenceRoutes } from './laisReferenceRoutes/routes';
import { routes as minhaLaisRoutes } from './laisSettings/routes';
import { routes as laisAccountRoutes } from './laisAccount/routes';
import { routes as laisFavoritesRoutes } from './laisFavorites/routes';
import { routes as prateleiraRoutes } from './laisPrateleira/routes';
import { routes as captacaoRoutes } from './laisCaptacao/routes';
import { routes as criarImovelRoutes } from './laisCriarImovel/routes';
import { routes as atualizacaoRoutes } from './laisAtualizacao/routes';
import { routes as laisLeadsRoutes } from './laisLeads/routes';
import { routes as laisHistoryRoutes } from './laisHistory/routes';
import { routes as laisAreaQprecoRoutes } from './laisAreaQpreco/routes';
import { routes as laisTenantsRentFlowsRoutes } from './laisTenantsRentFlows/routes';
import { routes as laisMeuAluguelRoutes } from './laisMeuAluguel/routes';
import { routes as redirectingRoutes } from './redirecting/routes';
import { routes as laisSupportRoutes } from './laisSupport/routes';
import { routes as laisInquiriesRoutes } from './laisInquiries/routes';
import { routes as laisDataRegistryRoutes } from './laisDataRegistry/routes';
import { routes as laisCondominiosRoutes } from './laisCondominios/routes';
import { routes as laisStoriesRoutes } from './laisStories/routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...canalproRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...laisReferenceRoutes,
        ...imoveisRoutes,
        ...visitasRoutes,
        ...financeiroRoutes,
        ...administracaoRoutes,
        ...relatorioRoutes,
        ...brandVoiceRoutes,
        ...realEstateRoutes,
        ...operacaoImobiliariaRoutes,
        ...pendingMarketUpdatesRoutes,
        ...mudancasRoutes,
        ...planosRoutes,
        ...inicioRoutes,
        ...minhaLaisRoutes,
        ...laisAccountRoutes,
        ...laisFavoritesRoutes,
        ...prateleiraRoutes,
        ...captacaoRoutes,
        ...criarImovelRoutes,
        ...atualizacaoRoutes,
        ...laisLeadsRoutes,
        ...laisHistoryRoutes,
        ...laisAreaQprecoRoutes,
        ...laisTenantsRentFlowsRoutes,
        ...laisMeuAluguelRoutes,
        ...laisSupportRoutes,
        ...laisInquiriesRoutes,
        ...laisDataRegistryRoutes,
        ...laisCondominiosRoutes,
        ...laisStoriesRoutes,
        ...redirectingRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
